import { PaginatedApiFetcher } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import createRepository from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import { PaginatedResponse } from '../../../types/request.types';
import { Connection } from '../myNetwork.types';

const PATH = '/connections';

export const findConnections: PaginatedApiFetcher<Connection> = (params, signal) =>
  restApi.get<PaginatedResponse<Connection>>(PATH, params, { signal });

export const myNetworkConnectionsRepository = (id: string) => {
  const repository = createRepository({
    path: PATH,
    id,
    restApi,
  });

  const updateSalesReps = (salesRepresentativesIds: string[]) =>
    restApi.patch(`${PATH}/${id}`, { salesRepresentativesIds });

  return {
    ...repository,
    updateSalesReps,
  };
};
